import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {CartSharedModule} from '@spartacus/cart/base/components';
import {CmsConfig, FeaturesConfigModule, I18nModule, provideDefaultConfig, UrlModule} from '@spartacus/core';
import {
  IconModule,
  ItemCounterModule,
  KeyboardFocusModule,
  PromotionsModule,
  SpinnerModule,
} from '@spartacus/storefront';

import {DcpAddToCartComponent} from './dcp-add-to-cart.component';
import {LoadingIndicatorComponent} from '@dcp/configurator';

import '@ui5/webcomponents/dist/BusyIndicator.js';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CartSharedModule,
    RouterModule,
    SpinnerModule,
    PromotionsModule,
    FeaturesConfigModule,
    UrlModule,
    IconModule,
    I18nModule,
    ItemCounterModule,
    KeyboardFocusModule,
    LoadingIndicatorComponent,
    DcpAddToCartComponent,
  ],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        ProductAddToCartComponent: {
          component: DcpAddToCartComponent,
        },
      },
    } as CmsConfig),
  ],
  exports: [DcpAddToCartComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DcpAddToCartModule {}
